import React, { useContext } from "react";
import FilterBar from "./FilterBar";
import MobileSubNav from "./MobileSubNav";
import NavContext from "contexts/NavContext";
import CONSTANTS from "components/FallRegistration/utils/constants";

const NavigationButtons = [
	// { name: "All", link: "/publications/books/all" },

	{ name: "Home", link: "/fall-institute" },
	{ name: "About", link: "/fall-institute/about" },
	// { name: "Hotel & Travel", link: "/fall-institute/travel" },

	// { name: "Featured Experiences", link: "/fall-institute/featured-experiences" },
	{ name: "Social Events", link: "/fall-institute/events" },
	// { name: "Volunteers", link: "/fall-institute/volunteer" },
	//{ name: "Schedule", link: "/fall-institute/schedule" },
	//{ name: "Agenda", link: "/fall-institute/agenda" },
	{ name: "Courses", link: "/fall-institute/courses" },
	{ name: "Vanguard", link: "/fall-institute/vanguard" },
	{ name: "Sponsors", link: "/fall-institute/sponsors" },

	// { name: "Hotel & Travel", link: "/fall-institute/travel" },
	// { name: "Sponsors & Partners", link: "/fall-institute/sponsors" },
];
NavigationButtons.title = `${CONSTANTS.FALL_YEAR} AAPL Fall Institute`;

const Desktop = ({ megaNavName, userDropdownOpen }) => {
	const { scrollHeaderLimit } = useContext(NavContext);

	return (
		<FilterBar
			isSlimNav={scrollHeaderLimit}
			filterButtons={NavigationButtons}
			hideAssessment={true}
			subNavScroll={650}
			isMiniSiteSubNav={true}
			className={megaNavName || userDropdownOpen ? "z-index-neg-1" : ""} //this class is made global in Layout.js
			withScroll={false}
		/>
	);
};

const Mobile = () => {
	return <MobileSubNav withScroll={false} navigation={NavigationButtons} subNavScroll={650} />;
};
//Sub navs
export default {
	Mobile: Mobile,
	Desktop: Desktop,
};
